<template>
  <a-dropdown :trigger="['click']">
    <div class="lang" :class="{'fixed': needFixed}">{{ langList[tabSelect] }} <a-icon type="down" /></div>
    <a-menu slot="overlay">
      <a-menu-item v-for="(value, key) in langList" :key="key" @click="onSwitchLang(key)">
        {{ value }}
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  props: {
    needFixed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      langList: {
        "en-US": "EN",
        "zh-CN": "中文",
        "ja-JP": "日本語",
        "kr-KP": "한국어",
      },
      tabSelect: 'en-US'
    };
  },
  methods: {
    // 切换语言
    onSwitchLang(lang) {
      
      localStorage.setItem("lang", lang); // 设置语言包
      this.$message.success({
        content: this.$t("userLogin.切换成功"),
        duration: 3000,
      });

      window.location.reload();
    },

  },
  created() {
    let lang = localStorage.getItem('lang') || 'en-US';
    this.tabSelect = lang;
  },
};
</script>

<style lang="scss" scoped>
.ant-select {
  width: 100px !important;
  background-color: transparent !important;
}
::v-deep .ant-select-selection {
  background-color: transparent !important;
  border: 1px solid #fff !important;
}
.lang {
  color: #fff;
  height: 31px;
  line-height: 31px;

  &.fixed {
    position: fixed;
    left: 20px;
    bottom: 20px;
  }
}
.lang-item {
  padding: 0 5px;
  font-size: 12px;
  border-right: 1px solid #fff;
  color: #fff;
  line-height: 16px;
  cursor: pointer;

  &:last-child {
    border: 0;
  }
}
</style>
